import gsap from 'gsap';
const $ = window.$ = window.jQuery = jQuery;
import { TimelineMax } from 'gsap/';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );
gsap.config({nullTargetWarn:false}); //remove warnings
// BANNER

const tlBanner = new TimelineMax( { paused: false } );
tlBanner
	// .to( '.landing__image', 7, { opacity: 1, ease: 'none', scale: 1.2 } )
	.from(
		'.landing__mask',
		1,
		{ opacity: 0, ease: 'power1.in(0.8)', y: '-100%' },
		'-=6'
	)
	.from( '.landing__title', 2, { autoAlpha: 0, ease: 'power3', y: -50 }, '-=5' )
	.from( '.landing__line', 0.2, { y: '100%', ease: 'power3' }, '-=5.5' )
	.from(
		'.site-header .container-fluid',
		0.5,
		{ autoAlpha: 0, ease: 'power3', y: '-100%' },
		'-=5.3'
	);

// ACCROCHE

const tlAccroche = new TimelineMax( {
	scrollTrigger: {
		trigger: '.accroche',
		start: 'bottom bottom',
		toggleActions: 'play none none reverse',
	},
} );

tlAccroche
	.from( '.accrocheTitle h2', 0.5, { autoAlpha: 0, y: '100%', ease: 'power3' } )
	.from(
		'.accrocheTitle p',
		0.5,
		{ autoAlpha: 0, y: '100%', ease: 'power3' },
		'-=0.2'
	);

//ABOUT

const tlAboutFirst = new TimelineMax( {
	scrollTrigger: {
		trigger: '.about__firstline',
		start: 'top bottom',
		// pin:true,
		scrub: 1,

		toggleActions: 'restart pause play pause',
	},
} );
if ( window.matchMedia( '(max-width: 992px)' ).matches ) {
	tlAboutFirst
		.from( '.firstlineImg1', 1, { y: '100%' } )
		.from( '.firstlineImg2', 1, { y: '100%' }, '-=0.2' );
} else {
	tlAboutFirst
		.from( '.firstlineImg1', 0.3, { y: '100%' } )
		.from( '.firstlineImg2', 0.3, { y: '100%' }, '-=0.2' );
}

const tlAboutSecond = new TimelineMax( {
	scrollTrigger: {
		trigger: '.about__secondline',
		start: 'top bottom',
		toggleActions: 'restart pause play pause',
		scrub: 1,
	},
} );

tlAboutSecond
	.from( '.secondlineImg', 1, { y: '100%' } )
	.from(
		'.about__secondline__desc h2',
		1,
		{ autoAlpha: 0, ease: 'power3.out(0.8)', y: 50 },
		'-=0.5'
	)
	.from(
		'.aboutText',
		1,
		{ autoAlpha: 0, ease: 'power3.out(0.8)', y: 50 },
		'-=0.3'
	);

if ( window.matchMedia( '(max-width: 1640px)' ).matches ) {
	const tlAboutThird = new TimelineMax( {
		scrollTrigger: {
			trigger: '.about__thirdline',
			start: 'top bottom',
			toggleActions: 'play none none none',
		},
	} );

	const counts = $( '.number' );
	counts.each( function() {
		const zero = { val: 0 };
		const countsTimeline = new TimelineMax( {
			scrollTrigger: {
				trigger: '.about__thirdline',
				start: 'top bottom',
				toggleActions: 'play none none none',
			},
		} );
		countsTimeline.to( zero, {
			val: $( this ).data( 'number' ),
			duration: 1,
			delay: 0,
			onUpdate: () => {
				$( this ).text( zero.val.toFixed( 0 ) );
			},
		} );
	} );

	tlAboutThird
		.from( '.thirdlineImgLeft', 1, { autoAlpha: 0, y: '100%' } )
		.from( '.thirdlineImgRight', 1, { autoAlpha: 0, y: '-100%' }, '-=1' )
		.staggerFrom(
			'.about__thirdline__desc--item',
			0.5,
			{ y: 50, ease: 'power3', opacity: 0 },
			0.2,
			'-=1.5'
		)
		.to( '.picto', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' )
		.to( '.libelle', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' )
		.to( '.number', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' );
} else {
	const tlAboutThird = new TimelineMax( {
		scrollTrigger: {
			trigger: '.about__thirdline',
			start: '-10% bottom',
			toggleActions: 'restart pause play pause',
			// toggleActions: "play stop reverse pause",
			// scrub : 0.2
		},
	} );

	const counts = $( '.number' );
	counts.each( function() {
		const zero = { val: 0 };
		const countsTimeline = new TimelineMax( {
			scrollTrigger: {
				trigger: '.about__thirdline',
				start: '25% bottom',
				toggleActions: 'restart pause play pause',
			},
		} );
		countsTimeline.to( zero, {
			val: $( this ).data( 'number' ),
			duration: 1,
			delay: 0,
			onUpdate: () => {
				$( this ).text( zero.val.toFixed( 0 ) );
			},
		} );
	} );

	tlAboutThird
		.from( '.thirdlineImgLeft', 1, { autoAlpha: 0, y: '100%' } )
		.from( '.thirdlineImgRight', 1, { autoAlpha: 0, y: '-100%' }, '-=1' )
		.staggerFrom(
			'.about__thirdline__desc--item',
			0.5,
			{ y: 50, ease: 'power3', opacity: 0 },
			0.2,
			'-=1.5'
		)
		.to( '.picto', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' )
		.to( '.libelle', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' )
		.to( '.number', 0.5, { opacity: 1, ease: 'power3' }, '-=0.2' );
}

/*var count = $(".number"),
    num = count.data("number");
*/

// LOCALISATION

const tlLocalisation = new TimelineMax( {
	scrollTrigger: {
		trigger: '.localisation',
		start: 'top bottom',
		// toggleActions: "play pause reverse pause",
		scrub: true,
		// markers:true
	},
} );

if ( window.matchMedia( '(max-width: 1640px)' ).matches ) {
	tlLocalisation
		.from( '.localisation__info--title', 0.5, { autoAlpha: 0, y: '100%' } )
		.from( '.localisationItem1', 0.5, { autoAlpha: 0, y: 20 }, '-=0.2' )
		.from( '.localisationItem2', 0.5, { autoAlpha: 0, y: 20 }, '-=0.2' )
		.from( '.localisationItem3', 0.5, { autoAlpha: 0, y: 20 }, '-=0.2' )
		.from( '.localisationItem4', 0.5, { autoAlpha: 0, y: 20 }, '-=0.2' )
		.from( '.mapImg', 0.5, { autoAlpha: 0, ease: 'power3' }, '-=1.2' )
		.to(
			'.mapPointer',
			0.7,
			{ autoAlpha: 1, ease: 'back.out(1)', scale: 1 },
			'-=1'
		);
} else {
	tlLocalisation
		.from( '.localisation__info--title', 0.5, { autoAlpha: 0, y: '100%' } )
		.from( '.localisationItem1', 0.5, { autoAlpha: 0, y: 20 }, '-=0.4' )
		.from( '.localisationItem2', 0.5, { autoAlpha: 0, y: 20 }, '-=0.4' )
		.from( '.localisationItem3', 0.5, { autoAlpha: 0, y: 20 }, '-=0.4' )
		.from( '.localisationItem4', 0.5, { autoAlpha: 0, y: 20 }, '-=0.4' )
		.from( '.mapImg', 0.5, { autoAlpha: 0, ease: 'power3' }, '-=0.8' )
		.to(
			'.mapPointer',
			0.7,
			{ autoAlpha: 1, ease: 'back.out(1)', scale: 1 },
			'-=1'
		);
}

// ACTIVITES

const tlActivites = new TimelineMax( {
	scrollTrigger: {
		trigger: '.activites',
		// pin:"#page",
		start: 'top bottom',
		// toggleActions: "play none none reverse",
		// scrub: 0.5,
		toggleActions: 'play none none none',
		/*scrub : true*/
	},
} );

tlActivites
	.from( '.activites__title', 0.5, { autoAlpha: 0, ease: 'power3', y: '100%' } )
	.staggerFrom( '.activites__slider--item', 0.5, { y: '100%', opacity: 0 }, 0.3 );

// ACTUS

const tlActus = new TimelineMax( {
	scrollTrigger: {
		trigger: '.news',
		start: 'top bottom',
		toggleActions: 'play none none none',
	},
} );

tlActus
	.from( '.news__title', 0.5, { autoAlpha: 0, ease: 'power3', y: '100%' } )
	.from( '.news__slider', 0.5, { autoAlpha: 0, y: '100%' }, '+=0.2' );

// PAGE TARIFS

const tlTarifsImg = new TimelineMax( {
	scrollTrigger: {
		trigger: '.tarifs',
		start: 'top bottom',
		// pin:true,
		scrub: 1,

		toggleActions: 'restart pause play pause',
	},
} );
if ( window.matchMedia( '(max-width: 992px)' ).matches ) {
	tlTarifsImg
		.from( '.tarifs__left--first', 1, { y: '15%' } )
		.from( '.tarifs__left--second', 1, { y: '25%' }, '-=0.2' );
} else {
	tlTarifsImg
		.from( '.tarifs__left--first', 0.3, { y: '15%' } )
		.from( '.tarifs__left--second', 0.3, { y: '25%' }, '-=0.2' );
}

const tlTarifs = new TimelineMax( {
	scrollTrigger: {
		trigger: '.tarifs',
		start: 'top bottom',
		// pin:true,
		scrub: 1,

		toggleActions: 'restart pause play pause',
	},
} );
if ( window.matchMedia( '(max-width: 992px)' ).matches ) {
	tlTarifs
		.from( '.tarifs__right--periodes', 1, { y: '20%' } )
		.from( '.tarifs__right--supp', 1, { y: '30%' }, '-=0.2' );
} else {
	tlTarifs
		.from( '.tarifs__right--periodes', 0.3, { y: '20%' } )
		.from( '.tarifs__right--supp', 0.3, { y: '30%' }, '-=0.2' );
}

// PAGE ACTUALITÉS
$( '.news__item' ).addClass( 'loaded' );
const tlActualites = new TimelineMax( {
	scrollTrigger: {
		trigger: 'body',
		// pin:"#page",
		start: 'top bottom',
		// toggleActions: "play none none reverse",
		// scrub: 0.5,
		toggleActions: 'play none none none',
		/*scrub : true*/
	},
} );

tlActualites
	.from( '.news', 0.5, { autoAlpha: 0, ease: 'power3', y: '100%' } )
	.staggerFrom( '.news__item', 0.5, { y: '100%', opacity: 0 }, 0.3 );

gsap.registerPlugin( ScrollTrigger );
